/** @jsx h */
import { Component, h, JSX } from 'preact';
import classNames from 'classnames';
import cssStyles from './index.css';
import { RootStore } from '../../../../common/js/stores/root.store';
import { EndScreen } from '../../lib/end-screen/end-screen';

interface VideoEndScreenImageProps {
  isMediumRectangleAdUnit: boolean;
  endScreen: EndScreen;
}

export default class VideoEndScreenImage extends Component<
  VideoEndScreenImageProps
> {
  render(): JSX.Element {
    const { isMediumRectangleAdUnit, endScreen } = this.props;
    const isVideoCompleted = RootStore.getInstance().videoStore.isVideoCompleted
      .value;

    const styles = {
      mediumRectangleEndScreen: {
        backgroundColor: isVideoCompleted ? 'white' : ''
      },
      endScreen: {
        backgroundColor: 'black'
      }
    };

    return (
      <div
        style={{
          backgroundImage: `url(${endScreen.content})`,
          ...(isMediumRectangleAdUnit
            ? styles.mediumRectangleEndScreen
            : styles.endScreen)
        }}
        className={classNames(cssStyles.endScreen, cssStyles.endScreenImage)}
        id="end_screen_image"
      />
    );
  }
}
